import { z } from "zod";
export const terminatableJobStatusSchema = z.union([z.literal("QUEUED"), z.literal("ALL")]);
//# sourceMappingURL=types.js.map